<template>
  <div>
    <!-- <div class="flex flex-col md:flex-row gap-4 md:gap-10 rounded-xl md:justify-evenly bg-[var(--c-primary)] p-8">
      <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{ $t('admin.actions.missingDoc') }}</ButtonWhite>
      <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{ $t('admin.actions.passSent') }}</ButtonWhite>
      <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{ $t('admin.actions.contractSigned') }}</ButtonWhite>
    </div> -->

    <div class="flex flex-col md:flex-row py-6 justify-between gap-4">
      <div class="flex w-full md:w-auto justify-between gap-4">
        <PrintTableComponent :title="$t('menu.users_ads')" :fields="fields" :items="items"
          @print-started="() => console.log($t('admin.table.print.started'))"
          @print-completed="() => console.log($t('admin.table.print.completed'))"
          @print-failed="(error) => console.error($t('admin.table.print.failed'), error)" />

        <RouterLink v-if="canCreateAdsUser" to="/new-ads-user">
          <ButtonWhite class="md:hidden flex items-center gap-2 text-[#385660]">
            {{ $t('admin.buttons.addNew') }}
            <PlusIcon />
          </ButtonWhite>
        </RouterLink>

      </div>

      <div class="flex md:gap-4">
        <RouterLink v-if="canCreateAdsUser" to="/new-ads-user">
          <ButtonWhite class="hidden md:flex items-center gap-2 text-[#385660]">
            {{ $t('admin.buttons.addNew') }}
            <PlusIcon />
          </ButtonWhite>
        </RouterLink>

      </div>
    </div>

    <TitlePrimary :title="$t('menu.users_ads')" class="w-full" />

    <div class="md:hidden">
      <CardTable :fields="fields" :items="items.length > 0 ? [items[currentItemIndex]] : []" :showOptions="false"
        route="/user-detail" :listOptions="optionsList" />
      <MobilePaginateComponent v-if="items.length > 0" :totalPages="totalPages" :modelValue="currentPage"
        :totalItems="totalItems" :currentItemIndex="currentItemIndex" :itemsPerPage="10"
        @update:modelValue="handlePageChange" @update:currentItemIndex="handleItemChange" />
    </div>

    <div class="hidden md:block">
      <TableComponent :filter-definitions="filterDefinitions" :filter-error="filterError" v-model:filters="filters" @filter-change="onFilterChange" :fields="fields" :items="items" :showViewMoreButton="true" route="/user-detail"
        :listOptions="[]" />

      <PaginateComponent :totalPages="totalPages" :paginationInfo="paginationInfo" :modelValue="currentPage" @update:modelValue="handlePageChange" />

    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { useTableFilters } from '@/composables/useTableFilters';
import { isAdsManager } from '@/services/userRoles';

import TableComponent from '@/components/table/TableComponent.vue';
import PaginateComponent from '@/components/paginate/PaginateComponent.vue';
import { usePaginationInfo } from '@/composables/usePaginationInfo';
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import PrintTableComponent from '@/components/print/PrintTableComponent.vue';
import CardTable from '@/components/table/CardTable.vue';
import MobilePaginateComponent from '@/components/paginate/MobilePaginateComponent.vue';
import PlusIcon from '@/assets/svg/PlusIcon.vue';
import TitlePrimary from '@/components/title/title-primary.vue';

// --- Estado ---
const items = ref([]);
// Dan de alta usuarios ADS el responsable y Back Office (ADSREC-0007).
const canCreateAdsUser = isAdsManager();
// Perfiles internos más los gestores del legacy que conservan un rol de
// cliente y llevan cuentas como comercial (ADSREC-0008).
const adsStaff = 'ads_staff';
const searchText = ref('');
const { t } = useI18n();
const currentPage = ref(1);
const totalPages = ref(1);
const { paginationInfo, setPaginationInfo } = usePaginationInfo();
const isSearchActive = ref(false);
const selectedFilterName = ref({ key: '', label: '' });
const currentItemIndex = ref(0);
const totalItems = ref(0);

const optionsList = ref([])

const formatDateDMY = (dateValue) => {
  if (!dateValue) return '-';

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '-';

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = String(date.getFullYear());

  return `${day}/${month}/${year}`;
};

const mapAccountTypeFromRoles = (users = []) => {
  return users.map((user) => {
    const type = user.roles && Array.isArray(user.roles)
      ? user.roles.map((role) => role.name).filter(Boolean).join(', ')
      : '';

    return {
      ...user,
      // «Cuenta» es la persona: nombre y apellidos, no el usuario de acceso,
      // que muchas veces repite el correo (ADSREC-0008).
      name: [user.name, user.surname].filter(Boolean).join(' '),
      created_at: formatDateDMY(user.created_at),
      type: type || '-'
    };
  });
};

// --- funciones ---
const fetchDataFromApi = async () => {
  isSearchActive.value = false;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/search`,
      {
        params: { role: adsStaff, per_page: 10, page: currentPage.value },
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      }
    );

    if (response.data?.value?.data) {
      items.value = mapAccountTypeFromRoles(response.data.value.data);
      totalPages.value = response.data.value.last_page;
      setPaginationInfo(response.data.value);
      currentPage.value = response.data.value.current_page;
      totalItems.value = response.data.value.total || items.value.length;
    }
  } catch (error) {
    items.value = [];
    console.error('Error fetching data:', error);
  }
};

const handlePageChange = async (newPage) => {
  currentPage.value = newPage;
  if (isFiltering.value) {
    await runSearch(newPage);
  } else {
    await fetchDataFromApi();
  }

};
const handleItemChange = (newIndex) => {
  if (newIndex >= 0 && newIndex < items.value.length) {
    currentItemIndex.value = newIndex;
  }
};

async function performSearch(searchEndpoint, perPage, page = 1) {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${searchEndpoint}`,
      {
        params: {
          query: searchText.value,
          per_page: perPage,
          page: page,
          search_by: selectedFilterName.value.key,
          role: adsStaff
        }
      }
    );
    console.log('search-results', response.data);
  } catch (error) {
    console.log('search-error', error);
  }
}
defineExpose({ performSearch });

onMounted(() => {
  fetchDataFromApi();
});


const fields = [
  { key: "id", label: "Codigo" },
  { key: "name", label: "Cuenta" },
  { key: "email", label: "Correo" },
  { key: "created_at", label: "Fecha de alta" },
  // Documento de identidad de la persona, como pidió ADS (ADSREC-0008).
  { key: "dni_nie", label: "DNI/CIF/NIE" },
  { key: "type", label: "Tipo de Cuenta" },
  { key: "commercial", label: "Asesor/comercial" },
  { key: "opciones", label: "Opciones" },
];

// --- filtros de cabecera ---
const ACCOUNT_TYPES = ['admin', 'superadmin', 'comercial'];

const filterDefinitions = computed(() => [
  { key: 'id', type: 'text' },
  // El back busca cada palabra en el nombre o en el apellido.
  { key: 'name', type: 'text' },
  { key: 'email', type: 'text' },
  { key: 'created_at', type: 'date' },
  { key: 'dni_nie', type: 'text' },
  {
    key: 'type',
    type: 'select',
    options: ACCOUNT_TYPES.map((value) => ({ value, label: t(`common.requestTypes.${value}`) })),
  },
  { key: 'commercial', type: 'text' },
]);

const { filters, isFiltering, filterError, runSearch, onFilterChange } = useTableFilters({
  endpoint: '/user/search',
  perPage: 10,
  translate: t,
  // El listado sólo muestra estos perfiles; la búsqueda cubre el mismo universo.
  extraParams: () => ({ role: adsStaff }),
  onResults: (data) => {
    const page = data?.value;
    if (!page) return;
    items.value = mapAccountTypeFromRoles(page.data || []);
    totalPages.value = page.last_page || 1;
    setPaginationInfo(page);
    currentPage.value = page.current_page || 1;
    isSearchActive.value = true;
  },
  onCleared: () => {
    isSearchActive.value = false;
    currentPage.value = 1;
    fetchDataFromApi();
  },
});

</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
